import React from 'react';

const Button = ({children, className, loading, ...props}) => {
  let classes = className;
  classes += loading ? ' button--preloader button--disabled-filled button--filled': '';

  const fieldProps = {
    ...props,
    className: classes,
  };

  return (
    <button type="button" {...fieldProps}>
      {loading ? <span className="dots"></span> : children}
    </button>
  );
};

export default Button;
